// extracted by mini-css-extract-plugin
export default {"inboxFooter":"PortalCommunicationInbox_inboxFooter__4l2vM","buttonGroupContainer":"PortalCommunicationInbox_buttonGroupContainer__0ZqPv"};